import React from 'react'
import AssetCategoryList from '../../components/assetcategorycomponents/AssetCategoryList'
import { useSelector } from 'react-redux';


function AssetCategoryDetails({renderPageContent}) {
    const headerName= useSelector(state => state.authendicationReducer.headerName); 

    if (headerName === 'Hospital Masters') {
        return (
            <>
                <AssetCategoryList renderPageContent={renderPageContent} />
            </>
        );
    } else {
        // If headerName doesn't match, return null or any other desired behavior
        return null; // or any other fallback component
    }
}

export default AssetCategoryDetails;